var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{class:{ 'toggled': _vm.Editor.isActive('heading', { level: 4 }) },attrs:{"Editor":_vm.Editor,"KnownIcon":"H4"},on:{"ToolClick":function($event){_vm.Editor.chain().focus().toggleHeading({level:4}).run()}}})}
var staticRenderFns = []

export { render, staticRenderFns }